class Array{
    constructor(){
        this.array = [];
    }
    placeArray(extArray){
        this.array = extArray;
    }
    returnArray(){
        return this.array;
    }
}

const mainArray = new Array();
export default mainArray;